import Settings from './SettingsActions'
import settings from '../virtuoso/settings';
import {namespaces} from '../semantic/settings';

/** Описание элементов для значений по умолчанию
 * Определяет текущий граф, текущий язык и доступные языки, пространства имён
*/

const initialVSetState = {
  graph: null,
  lang: settings.defaultLocale,
  isSignedIn: true,
  languages: ["ru", "en"],
  xmlns:namespaces,
  sksaNamespace: "http://purl.semanticpro.org/sksa",
  //Настройки для отображения xWiki
  xwiki: {
    filters:[ 
      {id: "xwiki:Help", present: false}, 
      {id: "xwiki:Menu", present: false}, 
      {id: "xwiki:XWiki", present: false}, 
      {id: "xwiki:SUZ", present: false},
      {id: "xwiki:Sandbox", present: false},
    ]
  },
  //Настройки для отображения таксономии. 
  //Ключ all - настройки для всех элементов. 
  //Ключ со значением URI классификатора  - настройки только для этого классификатора (настройки перекрывают all)
  //expandIsOne - открывать все элементы, если в таксономии только этот классификатор (один в списке)
  //showStatistic - рассчитывать количество элементов (с учётом наложенных фильтров)
  //hideZero - скрывать элементы, имеющие в статистике значение 0 (кроме случая, когда статистика содержит все нули)
  //
  taxonomy: {
     all: { expandIsOne: true, showStatistic: true, hideZero: true},
    "http://purl.semanticpro.org/authority/section":{ expandIsOne: true, hideZero: false}
  },
  /** Флаг принадлежности к определенной группе на основе списока групп, которые назначены пользователю и */
  inGroup: {
    Demo: true,
    Expert: false,
    Operator: false,
    PowerUser: false
  },
  catalog: {
    //IRI публичного каталога
    public: settings.catalog.public,
    //IRI закрытого (для авторизованных пользователей) каталога
    signed: settings.catalog.signed,
  },
  graph: {
    //IRI графа с публичным каталогом
    public: settings.catalog.graph.public,
    //IRI графа с закрытым (для авторизованных пользователей) каталогом
    signed: settings.catalog.graph.signed,
  },
  pch: "default" //Сокращение от permissions of the copyright holder (разрешения правообладателя)
  //Может иметь значения "default", "no", "yes"
}

export const vset = (state = { ...initialVSetState} , action) => {
    switch (action.type) {
        case "Settings.GRAPH":
            return{
                ...state,
                graph: action.graph
            }
        case "Settings.LANG":
            settings.catalog.lang = action.lang;
            return{
                ...state,
                lang: action.lang
            }
        case "Settings.SIGNED":
            return{
                ...state,
                isSignedIn: action.isSignedIn
            }
        case "Settings.GROUPS":
            return{
                ...state,
                inGroup: {
                  Demo: action.groups["Demo"],
                  Expert: action.groups["Expert"],
                  Operator: action.groups["Operator"],
                  PowerUser: action.groups["PowerUser"],
                  // Demo: action.groups.filter(group => group.name == 'CatalogDemo').length > 0,
                  // Expert: action.groups.filter(group => group.name == 'CatalogExpertGroup').length > 0,
                  // Operator: action.groups.filter(group => group.name == 'CatalogOperatorGroup').length > 0,
                  // PowerUser: action.groups.filter(group => group.name == 'CatalogPowerUsers').length > 0
            },
            }
        case "Settings.INFO":
            return{
                ...state,
                pch: action.info["Licensed"]
            }
        case "Settings.NAMESPACE":
          const { prefix, namespace } = action;
          if (prefix == "sksa")
            return {
              ...state,
              sksaNamespace: namespace,
            };
          
          const xmlns = state.xmlns || [];
          const exists = xmlns.some(item => item.ns === prefix);
          return {
            ...state,
            namespaces: exists
              ? xmlns.map(item => item.ns === prefix? { ...item, uri: namespace } : item)
              : [...namespaces, { ns: prefix, uri: namespace }]
          };

        case "Settings.NAMESPACES":
          return {
            ...state, 
            xmlns: action.namespaces,
          }

        case "Settings.LINGUISTIC_SYSTEM":  
          const { langs }  = action ;
          return {
            ...state, 
            languages: (Array.isArray(langs) && langs.length>0)?langs: initialVSetState.languages
          }
        default:
            return state;
    }
}

